import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe which transforms a string identifier for a bookmaker, into a string representing a valid CSS colour
 * which is to be used as a foreground colour on elements styled in the branding of that bookmaker. In other words,
 * given the same identifier, the result of this pipe should be a contrast to the result of the
 * [`BookBackgroundColourPipe`](./book-background-colour.pipe.ts).
 */
@Pipe({
  name: 'bookForegroundColour'
})
export class BookForegroundColourPipe implements PipeTransform {

  /**
   * A pipe which transforms a string identifier for a bookmaker, into a string representing a valid CSS colour
   * which is to be used as a foreground colour on elements styled in the branding of that bookmaker. In other words,
   * given the same identifier, the result of this pipe should be a contrast to the result of the
   * [`BookBackgroundColourPipe`](./book-background-colour.pipe.ts).
   * @param bookName the identifier code for the bookmaker object, as returned by the sport data APIs
   * @returns a colour string for the preferred foreground colour matching this bookmaker (either a named colour or
   * a hex string preceded by a `"#"`), or `"initial"` if the identifier does not match one of the recognised identifiers
   */
  transform(bookName: string): string {
    switch (bookName?.toLowerCase()) {
      case "betstreet":
        return "white";
      case "fanduel":
        return "white";
      case "sugarhouse":
        return "white";
      case "pointsbet":
      case "pointsbet_au":
        return "white";
      case "william_hill":
        return "white";
      case "draftkings":
        return "white";
      case "wynn":
        return "white";
      case "betmgm":
        return "black";
      case "bet_rivers_in":
      case "bet_rivers_va":
      case "bet_rivers_co":
        return "#18355e";
      case "bet365":
      case "bet_365":
        return "white";
      case "betway":
        return "white";
      case "unibet":
        return "white";
      case "tipico":
        return "#fdfcfc";
      case "twinspires":
        return "white";
      case "bluebet":
        return "white";
      case "topsport":
        return "white";
      case "betfair":
        return "black";
      default:
        return "white"
    }
  }
}
